import React from 'react';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Divider
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { getContrastText } from '../utils/colorUtils';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

function PageLayout({ title, onAdd, hideAddButton, children, customColors, actionButtons, addButtonText, hideLogo, hideTitle, hideFooter, compactHeader, hideActionHeader }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { currentUser } = useAuth();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      width: '100%',
      mt: { xs: '31px', sm: '64px' },
      overflow: 'visible'
    }}>
      {/* Logo centralizado */}
      {!hideLogo && (
        <Box
          component="div"
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 1,
            backgroundColor: 'background.default',
            mb: { xs: 1, sm: 4 }
          }}
        >
          <Box
            component="img"
            src={isDarkMode ? logo2 : logo}
            alt="Habitop Logo"
            sx={{
              height: { xs: 90, sm: 100 },
              width: 'auto',
              mb: 0,
              mt: -5
            }}
          />
        </Box>
      )}

      {/* Conteúdo principal */}
      <Box sx={{ 
        p: { xs: 0.5, sm: 3 },
        pt: { xs: 0.5, sm: 2 },
        maxWidth: 1800,
        mx: 'auto',
        width: '100%',
        flex: 1,
        overflow: 'visible'
      }}>
        {!hideActionHeader && (
          <Box sx={{
            mb: { xs: 1, sm: 4 },
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: { xs: 'flex-start', sm: 'space-between' },
            gap: { xs: 1, sm: 0 },
            minHeight: { xs: 48, sm: 'auto' }
          }}>
            {!hideTitle && !isMobile && (
              <Typography
                variant="h4"
                fontWeight="bold"
                color={customColors?.primary || 'primary.main'}
                sx={{ fontSize: '2rem', flexShrink: 0, mb: 0, mt: 0 }}
              >
                {title}
              </Typography>
            )}
            {actionButtons && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, m: 0, width: { xs: '100%', sm: 'auto' } }}>{actionButtons}</Box>
            )}
          </Box>
        )}
        {children}
      </Box>

      {/* Rodapé */}
      {!hideFooter && (
        <Box sx={{ 
          mt: 'auto',
          width: '100%',
          p: { xs: 1, sm: 2 }
        }}>
          <Divider />
          <Box sx={{ 
            mt: 2,
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5
          }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: customColors?.primary ? `${customColors.primary}99` : 'text.secondary'
              }}
            >
              {currentUser?.email}
            </Typography>
            {currentUser?.displayName && (
              <Typography 
                variant="body2"
                sx={{ 
                  color: customColors?.primary ? `${customColors.primary}99` : 'text.secondary',
                  fontWeight: 500
                }}
              >
                {currentUser.displayName}
              </Typography>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default PageLayout; 